import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Layout from '../CommonComponents/Layout/Layout';
import AppContext from '../../context/AppContext';
import { SIDER_TABS } from '../../utils/Constants';

import SportsbookKpi from './Kpi/SportsbookKpi';
import BetsReport from './BetsReport/BetsReport';
import EventsList from './EventsList/EventsList';

function Sportsbook() {
  const { setActiveSidebarTab } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState('');

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.SPORTSBOOK, 'Sportsbook');

    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');

    if (tabParam) {
      const normalizedTab = tabParam
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());

      setActiveTab(normalizedTab);
    } else {
      setActiveTab('Sportsbook Kpi');
    }
  }, [location.search, setActiveSidebarTab]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);

    const tabParam = tabName.toLowerCase().replace(/\s+/g, '-');
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', tabParam);
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <Layout name={SIDER_TABS?.SPORTSBOOK}>
      {activeTab === 'Sportsbook Kpi' && (
        <SportsbookKpi activeTab={activeTab} setActiveTab={handleTabChange} />
      )}
      {activeTab === 'Events List' && (
        <EventsList activeTab={activeTab} setActiveTab={handleTabChange} />
      )}
      {activeTab === 'Latest Bets List' && (
        <BetsReport activeTab={activeTab} setActiveTab={handleTabChange} />
      )}
    </Layout>
  );
}

export default Sportsbook;
